module.exports = __webpack_public_path__ + "static/media/microphone.52fab1f2.svg";